"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.endAt = void 0;
var firestore_1 = require("firebase/firestore");
/**
 * Creates a {@link QueryConstraint} that modifies the result set to end at the
 * provided document (exclusive). The ending position is relative to the order
 * of the query. The document must contain all of the fields provided in the
 * orderBy of the query.
 *
 * @param snapshotOrFieldValues - The snapshot of the document to end at OR the field values to end this query at, in order
 * of the query's order by.
 * @returns A {@link QueryConstraint} to pass to `query()`
 */
// @ts-expect-error
var endAt = function () {
    var snapshotOrFieldValues = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        snapshotOrFieldValues[_i] = arguments[_i];
    }
    return {
        type: 'endAt',
        values: snapshotOrFieldValues,
        ref: (0, firestore_1.endAt)(snapshotOrFieldValues),
    };
};
exports.endAt = endAt;
